import { Icon } from '@chakra-ui/react';

export default function SFBoxWithPencil(props) {
  return (
    <Icon
      width={6}
      height='25px'
      viewBox='0 0 24 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='m18.967 7.352-1.07-1.079.57-.562c.258-.25.64-.281.883-.04l.18.188c.265.258.265.633 0 .914zm-9.399 8.523c-.148.062-.304-.117-.242-.25l.703-1.469 7.29-7.289 1.07 1.055-7.297 7.289zm-2.843 5.062c-1.625 0-2.454-.804-2.454-2.421v-9c0-1.61.829-2.422 2.454-2.422h8.851l-1.258 1.258h-7.57c-.781 0-1.219.421-1.219 1.234v8.867c0 .813.438 1.227 1.22 1.227h9.132c.547 0 .977-.414.977-1.227v-7.5l1.257-1.258v8.82c0 1.618-.812 2.422-2.218 2.422z' />
    </Icon>
  );
}
